export default __webpack_public_path__ + "static/media/delivery_method.b54ff164.svg";